import React from "react";
import { UserRoleE } from "../../../models/enums";
import { useAppSelector } from "../../../store/hooks";
import { selectDirection } from "../../../store/selectors/appSelectors";
import { selectCurrentUser } from "../../../store/selectors/authSelectors";
import { useTranslate } from "../../../utils/hooks/useTranslate";
import { P } from "../../Text/Text";
import Tooltip from "../../Tooltip/Tooltip";

/**
 * Floating button which can start the tour
 * */

const TakeTourFloatingButton = ({ setIsShownFirstTime, tourName }) => {
  const direction = useAppSelector(selectDirection);
  const user = useAppSelector(selectCurrentUser);
  const { t } = useTranslate();

  const handleClick = () => {
    setIsShownFirstTime(true);
  };

  return user && user.role !== UserRoleE.GlobalAdmin && user.role !== UserRoleE.GlobalAdminAndAdminContentManager && (
    <>
      <div
        className={`take-tour-floating-button floating-button-${direction}`}
        onClick={handleClick}
      >
        <Tooltip
          text={t`Show tutorial`}
        >
          <div className="floating-button-wrapper">
            <P>Show tutorial</P>
          </div>
        </Tooltip>
      </div>
    </>
  );
};

export default TakeTourFloatingButton;
